export const VISIT_NAME = 'visit_trackingURL';
export const TRACKER_UNKNOWN_VALUE = 'unknown';
